import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { TYRE_LOCATIONS } from "models";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { VehicleTyreReplacement } from "models";

type AddReplacementResponse = {
  data: { vehicle_tyre_replacement_id: number };
};

export const useAddTyreReplacementMutation = () =>
  useTypedMutation({
    mutationFn: (replacements: VehicleTyreReplacement[]) =>
      Promise.all(replacements.map(r => ApiInstance.post("/vehicle_tyre_replacements/create", r, ENV.appointmentBaseURL))),
    onSuccess: (replacements, results: AddReplacementResponse[]) => {
      if (!replacements.length) return;

      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.car?.tyres?.length) return;

      let hasUpdate = false;
      const tyres = [...appointment.car.tyres];
      for (let index = 0; index < replacements.length; index++) {
        const replacement = replacements[index];
        const tyreIdx = tyres.findIndex(t => t.location === TYRE_LOCATIONS.OnVehicle && t.axle === replacement.axle && t.position === replacement.position);

        replacement.id = results[index].data.vehicle_tyre_replacement_id;
        if (tyreIdx < 0 || tyres[tyreIdx].replacements?.some(r => r.id === replacement.id)) continue;

        tyres[tyreIdx] = { ...tyres[tyreIdx], replacements: (tyres[tyreIdx].replacements ?? []).concat(replacement) };
        hasUpdate = true;
      }

      if (hasUpdate) typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, car: { ...appointment.car, tyres } });
    }
  });
